import React from 'react';
import { Menu } from 'semantic-ui-react';
import styles from './Header.module.scss';

import ApplicationTitle from './ApplicationTitle';
import ApplicationLogo from './ApplicationLogo';
import Username from './Username';
import Logout from './Logout';
import ChooseLanguageWrapper from './ChooseLanguageWrapper';

function Header() {
  return (
    <Menu
      inverted
      borderless
      size="huge"
      fixed="top"
      fluid
      id="app-main-navbar"
      className={styles.header}
    >
      <Menu.Item>
        <div>
          <div className={styles.content}>
            <ApplicationLogo />
            <ApplicationTitle />
          </div>
        </div>
      </Menu.Item>
      <Menu.Menu position="right">
        <ChooseLanguageWrapper />
        <Username />
        <Logout />
      </Menu.Menu>
    </Menu>
  );
}

export default Header;
